import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { patchState, signalState } from '@ngrx/signals';
import { map, Subscription, take, tap } from 'rxjs';
import { AddRecipientService } from 'src/app/screens/add-recipient/services/add-recipient.service';
import { AddRecipientPageModule } from '../../../../add-recipient.module';
import { MaterialDoseComponent } from '../material-dose/material-dose.component';
import { ResponseModel } from '../../generic-vaccination.model';
import { VaccinatedInfoStoreData } from '../../vaccinated-info.signal.store';

export type State = {
  loading: boolean;
  error: Error;
  eligibileVaccines: any[];
};

@Component({
  selector: 'app-current-vaccination',
  templateUrl: './current-vaccination.component.html',
  styleUrls: ['./current-vaccination.component.scss'],
})
export class CurrentVaccinationComponent implements OnInit, OnDestroy {
  readonly addRecipientService = inject(AddRecipientService);
  readonly vaccinationInfoStore = inject(VaccinatedInfoStoreData);
  readonly state = signalState<State>({
    loading: false,
    error: null,
    eligibileVaccines: [],
  });
  benfSubscription: Subscription;
  verifiedData: any = {};

  constructor() {}

  ngOnInit(): void {
    this.benfSubscription = this.addRecipientService.benSuccessData.subscribe(
      (res) => {
        this.verifiedData = res;
        this.getEligibleVaccinesByBenf();
      }
    );
  }

  getEligibleVaccinesByBenf() {
    const params = {
      beneficiary_id: this.verifiedData?.beneficiary_id,
      session_id: this.verifiedData?.session_id,
    };
    this.addRecipientService
      .getuipMaterialdosedetails(params)
      .pipe(
        tap(() => patchState(this.state, { loading: true })),
        take(1),
        map((response: ResponseModel[]) => {
          patchState(this.state, {
            loading: false,
            eligibileVaccines: response || [],
          });
        })
      )
      .subscribe();
  }

  // calculateDoseWiseElibility(
  //   eligibleMaterials: ResponseModel[]
  // ): MaterialDoseEligibilityModel[] {
  //   return eligibleMaterials.map((e) => {

  //   });
  // }

  ngOnDestroy(): void {
    if (this.benfSubscription) this.benfSubscription.unsubscribe();
  }
}
